import { Stack, Typography } from '@mui/material';

import { ChatComposerContextBar } from '@/modules/common/Chat/components/ChatComposerContextBar';
import { COLORS } from '@/styles/tokens/colors';

import { HouseholdChatViewedContext } from '../hooks/useHouseholdChatViewedContext';
import { HouseholdChatPersonaChip } from './HouseholdChatPersonaChip';

interface HouseholdChatComposerContextBarProps {
  dismissViewedContext: () => void;
  isBlockedOnInteractiveMessage: boolean;
  onRemovePersona: () => void;
  personaDisplayName: string | null;
  viewedContext: HouseholdChatViewedContext | null;
}

function PendingInteractiveMessageBar() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        width: '100%',
        px: 1.5,
        py: 0.75,
        bgcolor: COLORS.GRAY[50],
        borderBottom: `1px solid ${COLORS.GRAY[200]}`,
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
      }}
    >
      <Typography variant="body-xs">
        Respond to the pending message to continue
      </Typography>
    </Stack>
  );
}

export function HouseholdChatComposerContextBar({
  dismissViewedContext,
  isBlockedOnInteractiveMessage,
  onRemovePersona,
  personaDisplayName,
  viewedContext,
}: HouseholdChatComposerContextBarProps) {
  if (isBlockedOnInteractiveMessage) {
    return <PendingInteractiveMessageBar />;
  }

  if (!viewedContext && !personaDisplayName) {
    return null;
  }

  return (
    <>
      {viewedContext && (
        <ChatComposerContextBar
          item={viewedContext.item}
          onRemove={dismissViewedContext}
        />
      )}
      {personaDisplayName && (
        <Stack direction="row" sx={{ width: '100%', px: 1.5, pt: 1 }}>
          <HouseholdChatPersonaChip
            displayName={personaDisplayName}
            onRemove={onRemovePersona}
          />
        </Stack>
      )}
    </>
  );
}
